import { IPageStatus } from '@elem/compPage/DP3/components/IPageStatus';
import Teaser from './teaser';
// import Landing from './landing';
import EfScrollAni from '@/efscrollani';
import QuoteWinFloat from '@elem/compCommon/ProductConstructor/BriefGuide/Info/QuoteWinFloat';
import QuoteWin from '@elem/compCommon/ProductConstructor/BriefGuide/Info/QuoteWin';
import { useState, useEffect, useMemo, useRef } from 'react';
import { useRouter } from 'next/router';
import HeaderUserTipsH5 from '@/app/eflayout/HeaderCommon/HeaderUser/HeaderUserNone/HeaderUserTipsWin/HeaderUserTipsH5';
import { getEfDeviceId } from 'lowcode/utils/getBrowserIdFromCanvas';
import { checkIsFirstVisitToday, recordTodayVisit, checkIsWithinTime, clearExpiredRecord } from '@/app/eflayout/Header/time';
import Crowdfunding from './CrowdFunding';
import { useDP3Store } from './DP3Provider';
import styles from './index.module.scss';
import ConsultationForm from './ConsultationForm';

export default function DP3() {
    // const [status, setStatus] = useState<IPageStatus>(pageStatus);
    // const dispatch = useDP3Dispatch();
    const { pageStatus } = useDP3Store();
    const { locale = 'us', pathname } = useRouter();
    const [isClient, setIsClient] = useState(false);
    const [openQuoteFlag, setOpenQuoteFlag] = useState(false);
    const [openForm, setOpenForm] = useState(true);
    const [showHeaderTips, setShowHeaderTips] = useState(true);
    const hasCheckedRef = useRef(false);
    if (typeof window !== 'undefined' && !window.AniContainer) {
        window.AniContainer = new EfScrollAni();
    }

    const isSpecifySite = useMemo(() => {
        if (locale === 'us') {
            return ['/delta-pro-3-portable-power-station', '/power-preparedness'].includes(pathname);
        }
        if (locale === 'de') {
            return ['/vanlife-roadtrips', '/recreational-activities'].includes(pathname);
        }
        return false;
    }, [pathname, locale]);

    const quoteCallback = (type: string) => {
        if (type === 'close') {
            setOpenQuoteFlag(false);
        } else if (type === 'open') {
            setOpenQuoteFlag(true);
        }
    };
    const formCallback = (type: string) => {
        console.log(type);
        if (type === 'close') {
            setOpenForm(false);
        } else if (type === 'open') {
            setOpenForm(true);
        }
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsClient(true);
        }
    }, []);

    useEffect(() => {
        if (hasCheckedRef.current) return;
        const checkDailyFirstVisit = async () => {
            if (!isSpecifySite) return;

            try {
                const deviceId = await getEfDeviceId();
                if (!deviceId) return;

                // 生成页面唯一标识
                const pageKey = `${locale}${pathname}`;
                // 检查是否为今日首次访问
                const isFirstVisit = checkIsFirstVisitToday(deviceId, pageKey);
                console.log({ isFirstVisit });
                if (isFirstVisit) {
                    // 记录今日访问
                    recordTodayVisit(deviceId, pageKey);
                    // 自己单独记录，不与open2逻辑交叉，显示弹窗
                    setShowHeaderTips(true);

                    // 10秒后自动关闭
                    setTimeout(() => {
                        setShowHeaderTips(false);
                    }, 5 * 1000);
                } else {
                    setShowHeaderTips(false);
                }
            } catch (error) {
                console.error('检查每日首次访问失败:', error);
            }
        };
        if (isSpecifySite && locale && pathname) {
            checkDailyFirstVisit();
        }
    }, [isSpecifySite, locale, pathname]);

    useEffect(() => {
        const isFlag = checkIsWithinTime(locale);
        if (isFlag) {
            return;
        }
        clearExpiredRecord();
        setShowHeaderTips(true);
        setTimeout(() => {
            setShowHeaderTips(false);
        }, 5 * 1000);
    }, []);
    return (
        <div className={`${styles.dp3} dp3-crowdfunding`}>
            {isSpecifySite && showHeaderTips && <HeaderUserTipsH5 />}
            {pageStatus === IPageStatus.statusA && <Teaser />}
            {pageStatus === IPageStatus.statusB && <Crowdfunding />}
            {pageStatus === IPageStatus.statusC && <Crowdfunding noHead={true} />}
            {locale === 'us' && isClient && <QuoteWinFloat callback={quoteCallback} />}
            {locale === 'jp' && openForm && <ConsultationForm callback={formCallback} />}
            {locale === 'us' && isClient && openQuoteFlag && <QuoteWin callback={quoteCallback} />}
        </div>
    );
}
